<template>
  <v-dialog v-model="dialog" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase"
        >Thêm phân công giảng dạy
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
        <v-form ref="form">
          <v-row>
            <v-col cols="6" class="pb-0">
              <AutocompleteClass
                v-model="classData"
                label="Lớp"
                outlined
                dense
                required
                @change="classChanged"
                class="required"
                :filter="classFilter"
                :rules="[$rules.required]"
                :disabled="disabledClass"
              />
            </v-col>
            <v-col cols="6" class="pb-0">
              <AutocompleteSubject
                return-object
                v-model="extraSubject"
                clear-icon="mdi-close"
                label="Môn học"
                outlined
                dense
                hide-details
                required
                disabled
              />
            </v-col>

            <v-col cols="12" class="py-0">
              <AutocompleteTeacherCard
                v-if="!defaultTeacher || !defaultTeacher.id"
                v-model="teacher"
                clear-icon="mdi-close"
                label="Giáo viên"
                outlined
                dense
                deletable-chips
                required
                class="required"
                :rules="[$rules.required]"
              />
            </v-col>
          </v-row>
        </v-form>
        <v-spacer style="height: 100px" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-btn color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import get from 'lodash-es/get'
import AutocompleteSubject from '@/components/basic/input/AutocompleteSubject'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard'
import { Teaching } from '../../plugins/api'

export default {
  components: {
    AutocompleteSubject,
    AutocompleteClass,
    AutocompleteTeacherCard,
  },
  props: {
    state: Boolean,
    defaultTeacher: {
      type: Object,
      default: () => {},
    },
    defaultClass: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      subject: '',
      classData: '',
      grade: null,
      id: '',
      extraSubject: null,
      classFilter: { type: 'extraCurriculum' },
      teacher: null,
      disabledClass: false,
    }
  },
  methods: {
    ...mapActions('teaching', ['createTeaching', 'updateTeaching', 'countIndependent']),
    classChanged() {
      this.extraSubject = get(this.classData, 'extraSubject')
    },
    async save() {
      if (!this.$refs.form.validate()) return
      const data = {
        subject: get(this.extraSubject, 'id'),
        teacher: get(this.teacher, 'id'),
        class: get(this.classData, 'id'),
        grade: get(this.classData, 'grade.id'),
        subjectGroup: get(this.extraSubject, 'subjectGroup'),
      }
      if (this.defaultTeacher && this.defaultTeacher.id) data.teacher = this.defaultTeacher.id
      if (this.defaultClass && this.defaultClass.id) data.class = this.defaultClass.id

      const countTeaching = await this.countIndependent({
        class: data.class,
        subject: data.subject,
        teacher: data.teacher,
      })
      if (countTeaching > 0) {
        return this.$alert.error('Giáo viên đã được phân công vào lớp này')
      }

      try {
        this.$loading.active = true

        const teachingList = await Teaching.fetch({
          class: data.class,
          subject: data.subject,
        })

        if (Array.isArray(teachingList) && teachingList.length) {
          await this.updateTeaching({ id: teachingList[0].id, ...data })
        } else {
          await this.createTeaching({ ...data })
        }

        this.$alert.success('Cập nhật thành công')
        this.dialog = false
        this.$refs.form.reset()
        this.$emit('done')
      } catch (error) {
        console.error(error)
        this.$alert.updateError()
      } finally {
        this.$loading.active = false
      }
    },
    cancel() {
      this.dialog = false
    },
  },
  watch: {
    state() {
      this.dialog = true

      if (this.defaultClass && this.defaultClass.id) {
        this.classData = this.defaultClass
        this.extraSubject = get(this.classData, 'extraSubject')
        if (this.classData && this.classData.id) this.disabledClass = true
        else this.disabledClass = false
      }
    },
  },
}
</script>
